import { useCopyClipboard } from "../../hooks/use-copy-clipboard";
import { CheckmarkIcon, CopyIcon } from "../../icons";

interface CopyButtonProps {
  toCopy: string;
  className?: string;
  iconClassName: string;
}

export function CopyButton({
  toCopy,
  className,
  iconClassName,
}: CopyButtonProps) {
  const [isCopied, setCopied] = useCopyClipboard(750);

  return (
    <button className={className} onClick={() => setCopied(toCopy)}>
      {isCopied ? (
        <CheckmarkIcon className={iconClassName} />
      ) : (
        <CopyIcon className={iconClassName} />
      )}
    </button>
  );
}
